import { Component, OnDestroy } from '@angular/core'
import { Store } from '@ngrx/store'
import { selectCaseNeighborhoodEnrichmentResults } from '../../state/case/case.selectors'
import { NeighborhoodEnrichmentResult } from '../../state/case/case.state'
import { Observable, Subject, takeUntil } from 'rxjs'
import { environment } from 'src/environments/environment'

@Component({
    selector: 'app-neighborhood-enrichment-result',
    templateUrl: './neighborhood-enrichment-result.component.html',
    styleUrls: ['./neighborhood-enrichment-result.component.scss'],
})
export class NeighborhoodEnrichmentResultComponent implements OnDestroy {
    neighborhoodEnrichmentData$: Observable<NeighborhoodEnrichmentResult[]>
    selectedEntry: NeighborhoodEnrichmentResult | undefined
    selectedResults: Set<NeighborhoodEnrichmentResult> = new Set([])
    private readonly destroy$ = new Subject<void>()
    private readonly wikiUrl = environment.wikiUrl

    constructor(private store: Store) {
        this.neighborhoodEnrichmentData$ = this.store.select(
            selectCaseNeighborhoodEnrichmentResults
        )
        this.neighborhoodEnrichmentData$.pipe(takeUntil(this.destroy$)).subscribe(data => {
            this.selectedResults.clear()
            this.selectedEntry = data[0]
            if (this.selectedEntry) this.selectedResults.add(data[0])
        })
    }

    addResult(): void {
        if (this.selectedEntry) this.selectedResults.add(this.selectedEntry)
    }

    removeResult(result: NeighborhoodEnrichmentResult): void {
        this.selectedResults.delete(result)
    }

    ngOnDestroy(): void {
        this.destroy$.next()
        this.destroy$.complete()
    }

    goToWiki(): void {
        window.open(
            `${this.wikiUrl}home/Navigation#clustering-analysis-neighborhood-enrichment`,
            '_blank'
        )
    }
}
